import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {ActionMethod, ActionOrigin} from 'constants/AnalyticsConstants';
import EntityStore from 'stores/EntityStore';
import {patchJSONPromise, postJSONPromise} from 'util/Net';
import {withLoadingScreen} from 'util/Promises';

import {RequestV2DefinitionGraphQL} from '../../../../graphql-fragments/processes/requests-v2/__generated/RequestV2DefinitionGraphQL';

export function requestV2DefinitionPageUrl(apiId: string): string {
  return `/${EntityStore.currentUser().url_identifier}/request-v2-templates/${apiId}`;
}

export interface CreateRequestV2DefinitionParams {
  name: string;
  taskSchemaId: string;
  templateCollectionId: string;
  prefix: string;
  description?: string;
  actionOrigin: ActionOrigin;
  actionMethod: ActionMethod;
}

export interface CreateRequestV2DefinitionResponse {
  createdIds: Array<string>;
}

export function createRequestV2Definition(
  requestV2Definition: CreateRequestV2DefinitionParams,
  message?: string,
  showLoadingScreen: boolean = true
): Promise<CreateRequestV2DefinitionResponse> {
  const creates = [requestV2Definition];
  const promise = postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.REQUEST_V2_DEFINITION),
    data: {creates},
  });
  if (showLoadingScreen) {
    return withLoadingScreen(promise, message || 'Creating request template...');
  }
  return promise;
}

export interface UpdateRequestV2DefinitionParams extends UpdateArchivableParams {
  id: string;
  name?: string;
  prefix?: string;
  description?: string;
  templateCollectionId?: string;
  actionOrigin: ActionOrigin;
  actionMethod: ActionMethod;
}

export interface UpdateRequestV2DefinitionResponse {
  updatedIds: Array<string>;
  requestV2Definitions: Array<RequestV2DefinitionGraphQL>;
}

export function updateRequestV2Definition(
  requestV2Definition: UpdateRequestV2DefinitionParams,
  message?: string,
  showLoadingScreen: boolean = true
): Promise<UpdateRequestV2DefinitionResponse> {
  const updates = [requestV2Definition];
  const promise = patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.REQUEST_V2_DEFINITION),
    data: {updates},
  });
  if (showLoadingScreen) {
    return withLoadingScreen(promise, message || 'Updating request template...');
  }
  return promise;
}
